export const uk = {
    'low-sum-hint': 'Пополните общий счет чтобы запустить ваши рекламные кампании',
    'wallet-button': 'Общий счет'
};
